
















import { Vue, Component, Emit } from "vue-property-decorator";
import { PermissionCommonSection, PermissionRight } from "@lib";
import AltAutoButton from "@/core/components/alt-auto-button";
import { ModalComponent } from "@core/components/alt-ui/modal";

@Component({
    name: "good-write-offs-toolbar",
    components: { AltAutoButton, ModalComponent },
})
export default class GoodWriteOffsToolbar extends Vue {
    @Emit("create")
    private startCreate(): void {
        return;
    }

    private toStore(): void {
        this.$router.push({ name: "stores" }).catch(() => {});
    }

    public constructor() {
        super();
    }

    private get can(): any {
        const secure = this.$secure;
        return {
            get create(): boolean {
                // TODO: добавить проверку прав
                return true;
            },
        };
    }
}
